import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerLookupComponent } from './customer-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [CustomerLookupComponent],
  exports: [CustomerLookupComponent]
})
export class CustomerLookupModule { }
